<template>
 <div>
  <textarea v-if="text != ''" style="width:100%;" rows="10" v-model="text"></textarea>
  <br>
  <FileReader @load="load"></FileReader>
  <label v-if="text != ''" class="upload-insert-button" @click="insert"> Insert into DB</label>
  <v-switch v-if="text != ''" class="upload-overwrite" label="Overwrite Existing" v-model="overwrite" ></v-switch>
  <label>{{err}}</label>
  <label @click="download" class="upload-insert-button">Download CSV Mailing List</label>
  <!-- <GenTable name="crm_contacts"></GenTable> -->
  <!-- <CartWrapper table="crm_contacts"></CartWrapper> -->
  <server-table-component 
    table="crm_contacts" newtable="crm_contacts" schema="sch_crm_contacts"
  ></server-table-component>
  </div>
</template>

<script>
// import GenTable from '@/library/TemplateTable'
import FileReader from '@/../../coreui/library/FileReader'
// import CartWrapper from '@/library/CartWrapper'
// import axios from 'axios'
import axiosInstances from '@/../../coreui/server/axiosInstances'
import { sync } from 'vuex-pathify'
export default {
  components: {
    // GenTable,
    // CartWrapper,
    FileReader
  },
  data: () =>({
    text: "",
    err: '',
    overwrite: false
  }),
  computed: {
    tableName: sync('tableName'),
    usePagination: sync('tableUseSSPagination')
  },
  methods: {
    load (event) {
      this.text = event
    },
    async insert () {
      let res = this.$papa.parse(this.text)
      let validkeys = ['name','company','dba', 'email','wphone','mphone','county','type','loc','first','last', 'notes']
      if (res.errors.length !== 0) {
        this.err = 'There were errors parsing this file'
      } else {
        let row1 = true
        let numfields = 0
        let keyord = []
        res.data.forEach(async x => {
          if (row1) {
            numfields = x.length
            keyord = validkeys.map(k => x.indexOf(k))
            row1 = false
          } else {
            let rec = {}
            validkeys.forEach((k, i) => { 
              let ix = keyord[i]
              if (ix != -1) {
                if (x[ix]) rec[k] = x[ix]
              } 
            })
            if (rec['name'] && !rec['first'] && !rec['last']) {
              let n = rec['name'].split(' ')
              let last = n[n.length-1]
              rec['first'] = n.slice(0, n.length-1).join(' ')
              rec['last']= last.charAt(0).toUpperCase() + last.slice(1)
              delete(rec.name)
            }
            // check if this email already exists
            let res = await axiosInstances.apiServer.get('/dt/v1/crm_contacts?email='+rec['email'])
            if (res.data != null && this.overwrite) {
              res.data.forEach(async y => {
                await axiosInstances.apiServer.delete('/dt/v1/crm_contacts/' + y._id)
              })
              this.$store.dispatch('addToDataTable', {name: this.tableName, item: rec})
              // console.log(res.data)
            }
            if (res.data == null) {
              // console.log(rec)
              this.$store.dispatch('addToDataTable', {name: this.tableName, item: rec})
            }
          }
        })
      }
      this.text=''
    },
    async download() {
      var d = await axiosInstances.apiServer.get('/dt/v1/'+ this.tableName + '?return=email&return=first&return=last')
      var res = 'Email Address,First Name,Last Name\n'
      d.data.forEach(x => {
        res += x.email + ',' + x.first + ',' + x.last + '\n'
      })
      let blob = new Blob([res], {type: 'text/csv'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'MailingList.csv';
      link.click();
      this.createExportLoading = false;
    }
  },
  mounted () {
    this.usePagination = true
  },
  beforeDestroy () {
    this.usePagination = false
  }
}
</script>
<style >
.upload-insert-button {
  position: relative;
  overflow: hidden;
  display: inline-block;

  /* Fancy button style 😎 */
  border: 2px solid;
  border-radius: 5px;
  padding: 8px 12px;
  cursor: pointer;
}

.upload-overwrite {
  position: relative;
  overflow: hidden;
  display: inline-block;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}
</style>